@if (show) {
  <div class="option" [formGroup]="formGroup()!">
    <div class="form-field-label" [ngStyle]="labelStyle">
      <app-text [formGroup]="formGroup()!" [model]="model()[meta().label.id]" [meta]="meta().label"></app-text>
    </div>
    <div class="form-field-value" [ngStyle]="valueStyle">
      <app-text [formGroup]="formGroup()!" [model]="model()[meta().value.id]" [meta]="meta().value"></app-text>
    </div>
    <div class="form-field-action">
      @if (!meta().noDelete) {
        <button type="button" matPrefix class="button" (click)="onDelete(model())"><mat-icon>delete</mat-icon></button>
      }
    </div>
  </div>
}
